import React from 'react';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <a href='https://twitter.com/RafhaanAbdulla' target="_blank" rel="noreferrer noopener">
        <div>
            <BsTwitter />
        </div>
        </a>
        <a href='https://www.instagram.com/rafhaan_abdulla/' target="_blank" rel="noreferrer noopener">
        <div>
            <BsInstagram />
        </div>
        </a>
        <a href='https://www.facebook.com/rafey.rappu.7/' target="_blank" rel="noreferrer noopener">
        <div>
            <FaFacebookF />
        </div>
        </a>
    </div>
  )
}

export default SocialMedia
